export default class BroadcastsSelected {
  public static readonly SET_DATA = "BROADCASTS_SELECTED_SET_DATA";
  public static readonly SET_STATUS = "BROADCASTS_SELECTED_SET_STATUS";
  public static readonly SET_ERROR = "BROADCASTS_SELECTED_SET_ERROR";
  public static readonly CLEAR = "BROADCASTS_SELECTED_CLEAR";

  public static setData(data: any) {
    return {
      data,
      type: BroadcastsSelected.SET_DATA,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: BroadcastsSelected.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: BroadcastsSelected.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: BroadcastsSelected.CLEAR,
    };
  }
}
